import React, { useState } from 'react';
import { Loader, Lock, AlertTriangle } from 'lucide-react';

export const AdminLogin = ({ onLogin, error, loading }) => {
  const [form, setForm] = useState({ username: '', password: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(form);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }} data-testid="admin-login-screen">
      <div className="card" style={{ width: '100%', maxWidth: '420px', padding: '2.5rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: '64px', height: '64px', borderRadius: '16px',
            background: 'var(--brand-gradient)', marginBottom: '1.25rem', boxShadow: 'var(--glow-purple)'
          }}>
            <Lock size={28} color="white" />
          </div>
          <h2 style={{ margin: '0 0 0.5rem', fontSize: '1.5rem' }}>Admin Access</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', margin: 0 }}>axpats management panel</p>
        </div>

        {error && (
          <div style={{
            background: 'var(--error-bg)', border: '1px solid rgba(239,68,68,0.3)',
            borderRadius: 'var(--radius-md)', padding: '0.875rem', marginBottom: '1.25rem',
            display: 'flex', alignItems: 'center', gap: '0.625rem'
          }} data-testid="login-error">
            <AlertTriangle size={18} color="var(--error)" />
            <span style={{ color: 'var(--error)', fontSize: '0.875rem' }}>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">Email</label>
            <input
              type="text"
              value={form.username}
              onChange={e => setForm(p => ({ ...p, username: e.target.value }))}
              required
              autoFocus
              data-testid="admin-username-input"
              className="form-input"
            />
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label">Password</label>
            <input
              type="password"
              value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              required
              data-testid="admin-password-input"
              className="form-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="btn btn-primary"
            style={{ width: '100%', marginTop: '0.5rem' }}
          >
            {loading ? <><Loader className="animate-spin" size={18} /> Signing in...</> : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};
